import React from 'react';
import { topTestimonials } from '../data/content';
import { TestimonialCard } from './TestimonialCard';
export function Testimonials() {
  return <section aria-labelledby="testimonios-titulo" className="w-full bg-white py-14 sm:py-20" data-id="element-263" data-mp="3kr5t64yb13k8">
      <div className="mx-auto max-w-5xl px-5" data-id="element-264" data-mp="3fxb2uio71qc6">
        <h2 id="testimonios-titulo" className="text-center font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-265" data-mp="3b1ch72u92mfg">
          ❤️ Lo que dicen quienes ya lo tienen
        </h2>

        <div className="mt-9 grid gap-5 sm:grid-cols-2" data-id="element-266" data-mp="31z3ayp60lf7v">
          {topTestimonials.map(testimonial => <TestimonialCard key={testimonial.name + testimonial.meta} testimonial={testimonial} data-id="element-267" data-mp="2x1bjtxd71x4q" />)}
        </div>
      </div>
    </section>;
}